import { render } from "./Calculate.vue?vue&type=template&id=1a6cbcba"
import script from "./Calculate.vue?vue&type=script&lang=ts"
export * from "./Calculate.vue?vue&type=script&lang=ts"
script.render = render

export default script